import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export function IconButton({ icon, onClick, variant = 'ghost', size = 'md', className = '', ...props }) {
    const sizeClasses = {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-10 h-10'
    };
    
    const variantClasses = {
        ghost: 'bg-transparent hover:bg-[var(--bg-subtle)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] border border-transparent',
        outline: 'bg-transparent border border-[var(--border)] hover:bg-[var(--bg-subtle)] text-[var(--text-primary)]',
        solid: 'bg-[var(--bg-surface)] border border-[var(--border)] shadow-sm hover:border-[var(--border-strong)] text-[var(--text-primary)]'
    };

    return (
        <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClick}
            className={`
                flex items-center justify-center rounded-md transition-colors cursor-pointer outline-none
                ${sizeClasses[size]} 
                ${variantClasses[variant]} 
                ${className}
            `}
            {...props}
        >
            <ObliqueIcon name={icon} size={size === 'sm' ? 14 : size === 'lg' ? 20 : 16} />
        </motion.button>
    );
}
